import React from "react";
import { compose } from "redux";
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import Tab from "app/components/Tab";
import { invokeIfFunction } from "utils/app.util";

const ModalTab = ({
  classes,
  children,
  value,
  selected,
  onClick,
  disabled,
  Icon,
  title,
  TabProps,
}) => (
  <Tab
    value={value}
    disabled={disabled}
    selected={selected}
    onClick={() => invokeIfFunction(onClick, value)}
    classes={{
      item: classes.tabItem,
      itemSelected: classes.tabItemSelected,
    }}
    {...TabProps}
  >
    {children}
    {Icon && <Icon color="secondary"></Icon>}
    {title && <Typography>{title}</Typography>}
  </Tab>
);

const styles = theme => ({
  tabItemSelected: {
    backgroundColor: theme.palette.background.paper,
  },
  tabItem: {
    minWidth: 150,
    display: "block",
    minHeight: "100%",
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    "& svg": {
      width: 50,
      height: 50,
      fill: theme.altus.background.header,
    },
    "& p": {
      fontWeight: 700,
    },
  },
  icon: {
    width: 50,
    height: 50,
  },
});

export default compose(
  React.memo,
  withStyles(styles),
)(ModalTab);
